import { OverflowTooltip } from 'library/tooltip';
import { DetailedHTMLProps, FC, ForwardedRef, HTMLAttributes, forwardRef } from 'react';

interface CardTitleProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    ref?: ForwardedRef<HTMLDivElement>;
}

const CardTitle = forwardRef<HTMLDivElement, CardTitleProps>((props, ref) => {
    const { children, className, ...rest } = props;

    return (
        <h6 ref={ref} {...rest} className={className}>
            <OverflowTooltip>{children}</OverflowTooltip>
        </h6>
    );
});

export default CardTitle;
